import { routeRefType } from './types.esm.js';

class ExternalRouteRefImpl {
  constructor(id, params, optional, defaultTarget) {
    this.id = id;
    this.params = params;
    this.optional = optional;
    this.defaultTarget = defaultTarget;
  }
  [routeRefType] = "external";
  toString() {
    return `routeRef{type=external,id=${this.id}}`;
  }
  getDefaultTarget() {
    return this.defaultTarget;
  }
}
function createExternalRouteRef(options) {
  return new ExternalRouteRefImpl(
    options.id,
    options.params ?? [],
    Boolean(options.optional),
    options?.defaultTarget
  );
}

export { ExternalRouteRefImpl, createExternalRouteRef };
//# sourceMappingURL=ExternalRouteRef.esm.js.map
